import React from 'react';
import classNames from 'classnames';
import { toast } from 'react-hot-toast';
import { Button } from '@salesforce/design-system-react';
import WalletAddressEllipsis from '../../../components/shared/WalletAddressEllipsis';

const AddressDetails = ({ address = '', name = '' }) => {
  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    toast.success('Successfully Copied');
  };

  return (
    <>
      <div
        className={classNames('slds-grid slds-grid_pull-padded slds-grid_vertical-align-center')}
      >
        <div className="transaction_detail_half_details">
          <div className="flex items-center">
            <span>Address</span>
          </div>
          <span title={address} className="hover:cursor-pointer">
            <WalletAddressEllipsis text={name.replace(/<[^>]*>?/gm, '')} maxTextCount={20} />
          </span>
        </div>
        <div
          className="transaction_detail_half_details"
          style={{
            marginRight: '15px',
            textAlign: 'right',
          }}
        >
          <Button
            style={{ marginRight: 12, marginBottom: 10 }}
            key="copy"
            label="Copy"
            onClick={() => handleCopy(address)}
            iconCategory="utility"
            iconName="copy"
            iconPosition="left"
          />
        </div>
      </div>
    </>
  );
};

export default AddressDetails;
